import Cookies from "js-cookie"
// import { useState } from "react"
// import toast from "react-hot-toast"

let activeApiRequests = 0
const apiActivityListeners = new Set()

const notifyApiActivityListeners = () => {
  const isApiRunning = activeApiRequests > 0
  apiActivityListeners.forEach((listener) => listener(isApiRunning))
}

const startApiRequest = () => {
  activeApiRequests += 1
  notifyApiActivityListeners()
}

const finishApiRequest = () => {
  activeApiRequests = Math.max(0, activeApiRequests - 1)
  notifyApiActivityListeners()
}

export const subscribeToApiActivity = (listener) => {
  apiActivityListeners.add(listener)
  listener(activeApiRequests > 0)

  return () => {
    apiActivityListeners.delete(listener)
  }
}

const apiClient = async (
  endpoint,
  method = "GET",
  body = null,
  headers = {},
) => {
  startApiRequest()

  const requestHeaders = { ...headers }

  // If faxAction exists, prepare X-Fax-Audit-Context
  if ("faxAction" in requestHeaders) {
    const auditContext = {}

    Object.keys(requestHeaders).forEach((key) => {
      // Keep appId as a normal header
      if (key === "appId") return

      auditContext[key] = requestHeaders[key]
      delete requestHeaders[key]
    })

    requestHeaders["X-Fax-Audit-Context"] = JSON.stringify(auditContext)
  }

  const options = {
    method,
    headers: requestHeaders,
    credentials: "include",
  }

  if (body instanceof FormData) {
    options.body = body // FormData handles its own Content-Type
  } else if (body) {
    options.body = JSON.stringify(body)
    options.headers["Content-Type"] = "application/json" // Only for JSON
  }

  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}${endpoint}`,
      options,
    )

    if (!response.ok) {
      const errorData = await response.json()
      const errorMessage =
        errorData.message || `HTTP error! Status: ${response.status}`

      if (response.status === 401) {
        const retryRes = await fetchWithRefresh({
          endpoint,
          method,
          body,
          headers,
        })
        return retryRes
      }

      if (response.status === 403) {
        Cookies.remove("user")
        window.location.href = "/"
      }

      throw errorMessage
    }

    return await response.json()
  } catch (error) {
    // console.log("-> ~ error:", error)
    throw error
  } finally {
    finishApiRequest()
  }
}

const fetchWithRefresh = async (options = {}) => {
  const refreshRes = await post("/oauth/refresh-token")
  if (refreshRes) {
    // ✅ return the retried response
    return await apiClient(
      options.endpoint,
      options.method,
      options.body,
      options.headers,
    )
  }
  return null
}

export const get = (endpoint, body, headers) =>
  apiClient(endpoint, "GET", body, headers)
export const post = (endpoint, body, headers) =>
  apiClient(endpoint, "POST", body, headers)
export const put = (endpoint, body, headers) =>
  apiClient(endpoint, "PUT", body, headers)
export const remove = (endpoint, body, headers) =>
  apiClient(endpoint, "DELETE", body, headers)
